module.exports = __webpack_public_path__ + "img/85f4e99.jpg";